import Welcome from '../../components/Welcome';
import NearbyAttractions from '../../components/NearbyAttractions';
import VacationDestination from '../../components/VacationDestination';
import TourStyle from '../../components/TourStyle';
import DreamExperienceSection from '../../components/DreamExperienceSection';
import TopAttraction from '../../components/TopAttraction';
import HomeMainBannerSection from '../../components/HomeMainBannerSection';

const Index = ({
    productList,
    isLoading,
    tourStyle,
    topAttractionList,
    nextLocations,
    nextTheme,
    attractionNearNextPageUrl,
    onClickLoadMore,
    isAttractionNearLoading,
    isTourStyleLoading,
    tourStyleNextPageUrl,
    isTopAttrLoading,
    topAttractionNextPageUrl,
    isDefLoading,
    isNextVacationLoading,
    nextLocationNextPageUrl,
    handleKeyUp,
    searchValue,
    setSearchValue,
    onClickReset,
    isSearchLoading,
    productsSuggetion,
    activitiesSuggetion,
    destinationSuggetions,
    onClickProduct,
    onClickDestination,
    onClickActivity,
    dropdownRef,
    suggetionHistory,
    setIsSearchFocused,
    isSearchFocused,
    searchKeyRef,
    blogsSuggetion,
    onClickBlog
}) => {
    return (
        <>
            <HomeMainBannerSection
                handleKeyUp={handleKeyUp}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onClickReset={onClickReset}
                isSearchLoading={isSearchLoading}
                productsSuggetion={productsSuggetion}
                blogsSuggetion={blogsSuggetion}
                activitiesSuggetion={activitiesSuggetion}
                destinationSuggetions={destinationSuggetions}
                onClickProduct={onClickProduct}
                onClickDestination={onClickDestination}
                onClickActivity={onClickActivity}
                dropdownRef={dropdownRef}
                suggetionHistory={suggetionHistory}
                setIsSearchFocused={setIsSearchFocused}
                isSearchFocused={isSearchFocused}
                searchKeyRef={searchKeyRef}
                onClickBlog={onClickBlog}
            />

            <NearbyAttractions
                productList={productList}
                isLoading={isDefLoading ? isDefLoading : isLoading}
                attractionNearNextPageUrl={attractionNearNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isAttractionNearLoading}
            />

            {
                nextLocations?.length > 0 &&

                <VacationDestination
                    nextLocations={nextLocations}
                    // nextTheme={nextTheme}
                    isLoading={isLoading}
                    isNextVacationLoading={isNextVacationLoading}
                    nextLocationNextPageUrl={nextLocationNextPageUrl}
                    onClickLoadMore={onClickLoadMore}

                />
            }
            {
                tourStyle?.length > 0 &&
                <TourStyle
                    tourStyle={tourStyle}
                    isTourStyleLoading={isTourStyleLoading}
                    tourStyleNextPageUrl={tourStyleNextPageUrl}
                    onClickLoadMore={onClickLoadMore}
                />
            }

            <DreamExperienceSection />

            {
                topAttractionList?.length > 0 &&
                <TopAttraction
                    topAttractionList={topAttractionList}
                    isTopAttrLoading={isTopAttrLoading}
                    topAttractionNextPageUrl={topAttractionNextPageUrl}
                    onClickLoadMore={onClickLoadMore}
                />
            }

            <Welcome />
        </>
    )
}
export default Index;